(function(algolia) {
  'use strict';

  if (algolia.config.powered_by) {
    // eslint-disable-next-line no-console
    console.log(
      "You're using Algolia !\n" +
        'Visit https://www.algolia.com/ for more insight about what we do.'
    );
  }

  /* Store variables */
  algolia.storeName = window.location.hostname
    .replace(/^www\./, '')
    .replace(/^([^.]*)\..*$/, '$1');

  /**
   * Checks whether we are on the `/search` page
   */
  algolia.full_results = Boolean(window.location.href.match(/\/search/));

  /**
   * Checks whether we are on a collection page
   */
  algolia.is_collection_results_page = Boolean(
    // We want to match `/collections/handle` but only if handle != 'all'
    window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all$)([^/]+)[/]*$/)
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all)(.*)$/)
  );

  /* Hide page content during InstantSearch loading */
  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;
  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;
  results_selector += ', .algolia-shopify-instantsearch';

  if (
    (algolia.full_results && algolia.config.instant_search_enabled) ||
    collectionPageEnabled
  ) {
    algolia.contentHide = new DOMParser().parseFromString(
      '<style>' + results_selector + ' { visibility: hidden }</style>',
      'text/html'
    ).head.firstElementChild;
    document.head.append(algolia.contentHide);
  }

  algolia.getTemplate = function getTemplate(name) {
    var el = document.getElementById('template_algolia_' + name);
    return el ? el.innerHTML : '';
  };

  // Current collection page ID
  var current_collection_id_string = algolia
    .getTemplate('current_collection_id')
    .replace(/^\s+|\s+$/g, '');

  if (current_collection_id_string) {
    try {
      var current_collection_id_object = JSON.parse(
        current_collection_id_string
      );
      algolia.current_collection_id =
        current_collection_id_object.currentCollectionID;
    } catch (error) {
      // Encountered an error while trying to parse the collection ID.
      // This most probably means that we aren't on a collection page.
    }
  }

  /* Add CSS block after current script */
  algolia.appendStyle = function appendStyle(content) {
    var scripts = document.getElementsByTagName('script');
    var currentScript = scripts[scripts.length - 1];
    var style = document.createElement('style');
    style.innerHTML = content;
    currentScript.parentNode.insertBefore(style, currentScript.nextSibling);
  };

  algolia.assign = function assign(to) {
    for (var i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i];
      for (var nextKey in nextSource) {
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey]; // eslint-disable-line no-param-reassign
        }
      }
    }
    return to;
  };

  /* Here because we need to ensure we have a fallback with '$ '. */
  algolia.money_format = algolia
    .getTemplate('money_format')
    .replace(/^\s+|\s+$/g, '');
  algolia.formatMoney = function formatMoney(cents) {
    var priceInCents = cents;

    /**
     * Uncomment the following block to support Shopify multi currency
     * and convert prices from store currency to the currency selected by
     * the user (aka "presentment" currency).
     * Please note that this relies on the `Shopify.currency` object exposed
     * by Shopify which is an undocumented feature and can change at any time.
     */
    if (
      typeof Shopify !== 'undefined' &&
      typeof Shopify.currency !== 'undefined' &&
      typeof Shopify.currency.rate !== 'undefined' &&
      typeof Shopify.currency.active !== 'undefined'
    ) {
      // Convert to "presentment" currency using the rate provided by Shopify
      priceInCents = priceInCents * Shopify.currency.rate;
      // Round up to the nearest whole number keeping in accordance with
      // the default rounding strategy of Shopify
      priceInCents = Math.ceil(priceInCents);
    
      /**
       * Shopify uses different rounding strategies for different currencies.
       * The logic below might need to be customised based on the active currencies.
       * Note: Please only include currencies other than your store currency.
       */
      // Round up to the 95th cent for EUR
     // Apply currency-specific rounding
       console.log(priceInCents+"===="+Shopify.currency.active+"===="+Shopify.currency.rate );
        if (Shopify.currency.active === 'INR' || Shopify.currency.active === 'DZD' || Shopify.currency.active === 'ALL' || Shopify.currency.active === 'AMD'  ||
            Shopify.currency.active === 'BDT' || Shopify.currency.active === 'XOF' || Shopify.currency.active === 'XAF'  || Shopify.currency.active === 'CVE'  ||
            Shopify.currency.active === 'KMF' || Shopify.currency.active === 'CRC' || Shopify.currency.active === 'DJF' || Shopify.currency.active === 'DOP' ||
            Shopify.currency.active === 'KZT'||Shopify.currency.active === 'JPY' || Shopify.currency.active === 'JMD'  || Shopify.currency.active === 'MWK' || 
            Shopify.currency.active === 'GYD'  || Shopify.currency.active === 'NGN' || Shopify.currency.active === 'NPR' || Shopify.currency.active === 'XPF' || 
            Shopify.currency.active === 'AFN' || Shopify.currency.active === 'HUF' || Shopify.currency.active === 'ISK' || Shopify.currency.active === 'KES' || 
            Shopify.currency.active === 'KGS' || Shopify.currency.active === 'MKD' || Shopify.currency.active === 'PKR' || Shopify.currency.active === 'RWF' || Shopify.currency.active === 'RSD'
            || Shopify.currency.active === 'LKR'||Shopify.currency.active === 'VUV' ||Shopify.currency.active === 'YER'
           ) {
                priceInCents = Math.ceil(priceInCents / 10000) * 10000;
        } else if (Shopify.currency.active === 'USD' || Shopify.currency.active === 'FJD' ) {
             var rawDollars = priceInCents / 100;
              var floored = Math.floor(rawDollars);
              var decimalPart = rawDollars - floored;
            
              if (decimalPart > 0.5) {
                priceInCents = (floored + 0.5) * 100; // Round down to X.50
              } else if (decimalPart > 0 && decimalPart < 0.5) {
                priceInCents = (floored + 0.5) * 100; // Also round up to X.50
              } else {
                priceInCents = rawDollars * 100; // Keep original if already .00 or .50
              }
        } else if (Shopify.currency.active === 'GNF' || Shopify.currency.active === 'IDR' || Shopify.currency.active === 'BIF' || 
                   Shopify.currency.active === 'KHR' ||  Shopify.currency.active === 'CDF'|| Shopify.currency.active === 'LAK'|| 
                   Shopify.currency.active === 'LBP' || Shopify.currency.active === 'MNT' || Shopify.currency.active === 'MMK' || 
                   Shopify.currency.active === 'PYG'|| Shopify.currency.active === 'VND' || Shopify.currency.active === 'STD'||
                   Shopify.currency.active === 'SLL' || Shopify.currency.active === 'TZS' || Shopify.currency.active === 'KRW'||
                    Shopify.currency.active === 'UGX' || Shopify.currency.active === 'UZS') {
         priceInCents = Math.ceil(priceInCents / 100000) * 100000;
        }  else if (Shopify.currency.active === 'EUR') {
            var euros = (priceInCents / 100);
            var decimal = euros - Math.floor(euros);          
            // If cents are greater than 0.95, round up to next full euro
            if (decimal >= 0.96) {
              priceInCents = Math.ceil(euros) * 100;
            } else {
              priceInCents = Math.round(priceInCents); // Keep original cents
            }
           priceInCents =  parseInt(priceInCents / 100, 10) * 100 + 95; // EUR-specific rounding
          
          
        } else if (
          Shopify.currency.active === 'GBP' || Shopify.currency.active === 'AUD' || Shopify.currency.active === 'AZN' || Shopify.currency.active === 'BSD' ||
         Shopify.currency.active === 'DKK' || Shopify.currency.active === 'XCD' || Shopify.currency.active === 'AWG' || Shopify.currency.active === 'SHP' ||
         Shopify.currency.active === 'BBD' || Shopify.currency.active === 'BZD'  || Shopify.currency.active === 'TJS'||Shopify.currency.active === 'PLN'
        ) {
           var pp_price = (priceInCents / 100);
            var decimal = pp_price - Math.floor(pp_price);       
                     if (decimal == 0.00) {
               priceInCents = Math.ceil(priceInCents / 100) * 100 ;
            } else {
               priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100; // Keep original cents
            }          
          // GBP, USD, DKK rounding
        } 
        else {
           priceInCents = Math.ceil(priceInCents / 100) * 100 ; // Default rounding
        }
     
    }

  var val;
  if (Shopify.currency && Shopify.currency.active === 'HUF') {
  // Use hu-HU locale for HUF formatting (e.g., 1 234 567,89)
  val = (priceInCents / 100.0).toLocaleString('hu-HU', {
     style: 'currency',
    currency: 'HUF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}else if (Shopify.currency && Shopify.currency.active === 'UZS') {
  val = (priceInCents / 100.0).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }) + ' som';
}
else if (Shopify.currency && Shopify.currency.active === 'PYG') {
  // Use es-PY locale for PYG formatting (e.g., ₲1.234.567,89)
  val = (priceInCents / 100.0).toLocaleString('es-PY', {
    style: 'currency',
    currency: 'PYG',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}else if(Shopify.currency && Shopify.currency.active === 'SEK') {
  val = (priceInCents / 100.0).toLocaleString('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}else if (Shopify.currency && Shopify.currency.active === 'VND') {
  val = (priceInCents / 100.0).toLocaleString('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
else if (Shopify.currency && Shopify.currency.active === 'XPF') {
  val = (priceInCents / 100.0).toLocaleString('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).replace(/\u202f/g, ' ').replace(/,/g, ' ') + ' XPF';
}
  else if (Shopify.currency && Shopify.currency.active === 'INR') {
   // Use en-IN locale for INR formatting (e.g., 1,23,456.78)
    val = (priceInCents / 100.0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    // Default to en locale for other currencies
    val = (priceInCents / 100.0).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
    var format = algolia.money_format;

    // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
    var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      return format.replace(regexp, '$1' + val + '$2');
    }

    regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      var money = val.replace(/[.]/, '|');
      money = money.replace(/[,]/, '.');
      money = money.replace(/[,]/, '.');
      money = money.replace(/[ ]/, '.');
      return format.replace(regexp, '$1' + money + '$2');
    }

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(priceInCents, format);
    }

    return val;
  };
})(window.algoliaShopify);
